define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpAssetReplace = void 0;
    class FWpAssetReplace extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WpAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsRemoveAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsRemoveAssetError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FWpAssetReplace.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FWpAsset = parent;
            this.WpAssetId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FWpAsset = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WpAssetId = (0, EntityUtil_1.toInt)(entity.WpAssetId);
            a.FAssetId = (0, EntityUtil_1.toInt)(entity.FAssetId);
            a.IsRemoveAsset = (0, EntityUtil_1.toInt)(entity.IsRemoveAsset);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FWpAssetReplace.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WpAssetId", "Works Project Asset Id");
                this.validateReqNumber(validationState, "FAssetId", "Replace this Asset");
                this.validateReqNumber(validationState, "IsRemoveAsset", "Will be Removed?");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WpAssetId: this.WpAssetId,
                FAssetId: this.FAssetId,
                IsRemoveAsset: this.IsRemoveAsset,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get FAsset() {
            if (this.FWpAsset && this.FWpAsset.FWorksProject && this.FWpAsset.FWorksProject.Facility) {
                return this.FWpAsset.FWorksProject.Facility.FAsset.find(a => a.Id == this.FAssetId);
            }
            return null;
        }
        get TypeDesc() {
            let a = this.FAsset;
            if (a) {
                return a.AssetType.AssetTypeDesc;
            }
            return "";
        }
        get TypeDescWithBarcode() {
            let a = this.FAsset;
            if (a) {
                return `${a.Barcode} - ${a.AssetType.AssetTypeDesc}`;
            }
            return "";
        }
    }
    exports.FWpAssetReplace = FWpAssetReplace;
    Object.defineProperty(FWpAssetReplace, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FWpAssetReplace"
    });
    Object.defineProperty(FWpAssetReplace, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Empty"
    });
    Object.defineProperty(FWpAssetReplace, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WpAssetId", "FAssetId", "IsRemoveAsset"]
    });
    Object.defineProperty(FWpAssetReplace, "WpAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpAssetReplace, "FAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpAssetReplace, "IsRemoveAssetReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetReplace.prototype, "WpAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetReplace.prototype, "WpAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetReplace.prototype, "FAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetReplace.prototype, "FAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetReplace.prototype, "IsRemoveAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetReplace.prototype, "IsRemoveAssetError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetReplace.prototype, "FWpAsset", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAssetReplace.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAssetReplace.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAssetReplace.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAssetReplace.prototype, "FAsset", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAssetReplace.prototype, "TypeDesc", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAssetReplace.prototype, "TypeDescWithBarcode", null);
});
